import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers"
import {MyAccountDTO} from "@/models/user"

const BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/my-account`

export async function getMyAccount(token: string): Promise<MyAccountDTO> {
    const response = await fetch(BASE_URL, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
        },
    })
    return await handleResponse<MyAccountDTO>(response) as MyAccountDTO
}

export async function requestEmailChange(newEmail: string, token: string): Promise<void> {
    assertTokenValidForMutation()
    const response = await fetch(`${BASE_URL}/email`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({newEmail}),
    })
    if (!response.ok) {
        const error = await response.json().catch(() => ({error: "Unknown error"}))
        throw new Error(error.error || "Email change request failed")
    }
}
